/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_Featured_InInputs */

const en_directory_detail_rail_featured_in = /** @type {(inputs: Directory_Detail_Rail_Featured_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured in`)
};

const zh_directory_detail_rail_featured_in = /** @type {(inputs: Directory_Detail_Rail_Featured_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录专题`)
};

/**
* | output |
* | --- |
* | "Featured in" |
*
* @param {Directory_Detail_Rail_Featured_InInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_featured_in = /** @type {((inputs?: Directory_Detail_Rail_Featured_InInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_Featured_InInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_featured_in(inputs)
	return zh_directory_detail_rail_featured_in(inputs)
});
export { directory_detail_rail_featured_in as "directory.detail.rail.featured_in" }